/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, styles, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...styles, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const informationChangesOption = [
  {
    value: "Đơn vị phát hành hóa đơn",
    label: "đơn vị phát hành hóa đơn",
    disabled: false,
  },
  {
    value: "Địa chỉ trụ sở chính",
    label: "địa chỉ trụ sở chính",
    disabled: false,
  },
  {
    value: "Điện thoại",
    label: "điện thoại",
    disabled: false,
  },
];


const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: 1,
      bg: true,
    },
    informationChanges: {
      type: "select",
      value: null,
      bg: false,
      option: informationChangesOption,
    },
    oldInfo: {
      type: "input",
      value: null,
      bg: false,
    },
    newInfo: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];
export default function ReiceiptTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: newIdValue,
        bg: true,
      },
      informationChanges: {
        type: "select",
        value: null,
        bg: false,
        option: informationChangesOption,
      },
      oldInfo: {
        type: "input",
        value: null,
        bg: false,
      },
      newInfo: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }} styles={{ width: "20%" }}>
                Thông tin thay đổi
              </Th>
              <Th style={{ textAlign: "center" }}>Thông tin cũ</Th>
              <Th style={{ textAlign: "center" }}>Thông tin mới</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row?.id?.value}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.informationChanges.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.informationChanges.bg ? (
                      row.informationChanges.value
                    ) : row.informationChanges?.type === "select" ? (
                      <SelectTable
                        name="informationChanges"
                        id={row.id.value}
                        option={
                          row.informationChanges.option
                            ? row.informationChanges.option
                            : defaultOption
                        }
                        style={{ width: "100%" }}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="informationChanges"
                        value={row.informationChanges.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.oldInfo.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.oldInfo?.type !== "input" ? (
                      row.oldInfo.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="oldInfo"
                        value={row.oldInfo.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.newInfo.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.newInfo?.type !== "input" ? (
                      row.newInfo.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="newInfo"
                        value={row.newInfo.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
